import { Globals } from "../CoreApp/Globals";
import { enumPanelBorderStyle } from "../constants";

export function AddTextEdit(
  theObj,
  panel,
  xPos,
  yPos,
  width,
  height,
  blankMsg,
  maxLen,
  tabID,
  addBorder
) {
  var te = theObj;
  te.PositionElement(xPos, yPos);
  te.SizeElement(width, height);
  te.SetResizeBehavior(true, true, false, false);
  te.SetBlankMessage(blankMsg);
  te.SetMaxLen(maxLen);

  if (tabID != -1) {
    te.SetTabID(tabID);
    panel.AddToTabList(te);
  }

  if (addBorder) {
    te.SetBorderStyle(enumPanelBorderStyle.singleBorder);
    te.SetBorderThickness(1);
    te.SetBorderColor(Globals._themeMode.text.alt);
  }
  if (te.GetNumRows() === 1) te.fVAlignment = "middle";
  te.fFontName = "Arial";
  te.fFontSize = 12;
  var teFill = Globals._themeMode.textedit.fill;
  var textColor = Globals._themeMode.text.header;
  te.SetFillColor(teFill);
  te.SetFontColor(textColor);
  panel.PushElement(te);
  return te;
}
